import React from "react";

import { BlueprintIcon, BlueprintIconProps } from "../blueprint-icon";

export const CallFilledIcon: React.FC<BlueprintIconProps> = (props) => (
  <BlueprintIcon viewBox="0 0 24 24" {...props}>
    <path d="M6.62 10.79L8.82 8.59C9.1 8.31 9.18 7.92 9.07 7.57C8.7 6.45 8.5 5.25 8.5 4C8.5 3.45 8.05 3 7.5 3H4C3.45 3 3 3.45 3 4C3 13.39 10.61 21 20 21C20.55 21 21 20.55 21 20V16.51C21 15.96 20.55 15.51 20 15.51C18.76 15.51 17.55 15.31 16.43 14.94C16.08 14.82 15.68 14.91 15.41 15.18L13.21 17.38C10.38 15.93 8.06 13.62 6.62 10.79Z" />
  </BlueprintIcon>
);